"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIGH_RISK_COUNTRIES = exports.OFAC_COUNTRIES = exports.X_GATEWAY_HEADER = void 0;
/**
 * @copyright
 * Copyright (c) 2021 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
exports.X_GATEWAY_HEADER = "X-GATEWAY";
exports.OFAC_COUNTRIES = new Set([
    // See https://home.treasury.gov/policy-issues/financial-sanctions/sanctions-programs-and-country-information
    "BY",
    "BI",
    "CF",
    "CU",
    "CD",
    "IR",
    "IQ",
    "LB",
    "LY",
    "ML",
    "NI",
    "KP",
    "RU",
    "SO",
    "SS",
    "SD",
    "SY",
    "UA",
    "VE",
    "YE",
    "ZW", // ZIMBABWE
]);
exports.HIGH_RISK_COUNTRIES = new Set([
    // Taken from https://skinconfig-webservice.integ.icfsys.com/v2/blockedcountry/all
    "AM",
    "AZ",
    "BD",
    "BF",
    "BH",
    "BW",
    "BY",
    "CD",
    "CI",
    "CK",
    "CN",
    "CO",
    "CU",
    "DZ",
    "EC",
    "EG",
    "GE",
    "GH",
    "GM",
    "GW",
    "GY",
    "HT",
    "ID",
    "IQ",
    "IR",
    "KE",
    "KG",
    "KH",
    "KP",
    "KZ",
    "LB",
    "LR",
    "LY",
    "MA",
    "MD",
    "MH",
    "MM",
    "MS",
    "MY",
    "NG",
    "NI",
    "NP",
    "PA",
    "PG",
    "PH",
    "PK",
    "PS",
    "RO",
    "RU",
    "SD",
    "SL",
    "SN",
    "SO",
    "SY",
    "TG",
    "TL",
    "TN",
    "TZ",
    "UA",
    "UG",
    "UZ",
    "VN",
    "VU",
    "YE",
    "ZW",
]);
